import parsePhoneNumber from 'libphonenumber-js/mobile';

export function passwordLengthValidate(password) {
  return password.length >= 12 && password.length <= 128;
}

export function passwordWithRepeatValidate(newPassword = '', repeatPassword = '') {
  return (
    newPassword === repeatPassword && passwordLengthValidate(newPassword) && passwordLengthValidate(repeatPassword)
  );
}

export const validateEmail = (email) => {
  /* eslint-disable no-useless-escape */
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  /* eslint-enable no-useless-escape */
  return re.test(String(email).toLowerCase());
};

// Params that can carry a referral code. `a` is ours; `red` is the parameter Reditus used for its
// affiliate slug, kept so links already published by former Reditus partners keep resolving - they
// now point at whichever workspace has claimed that code in our own program.
export const AFFILIATE_LINK_PARAMS = ['a', 'red'];

export function getAffiliateCodeFromLink(link) {
  try {
    const params = new URLSearchParams(new URL(link).search);
    const match = AFFILIATE_LINK_PARAMS.map((name) => params.get(name)).find(Boolean);

    return match || null;
  } catch (error) {
    return null;
  }
}

export function validateAffiliateLink(link) {
  return !!getAffiliateCodeFromLink(link);
}

export function validatePhone(_, data) {
  try {
    const number = parsePhoneNumber(`+${data?.phone?.replace(/\D/g, '')}` || '', data?.countryCode?.toUpperCase());
    return number.isValid();
  } catch (err) {
    return false;
  }
}

export function validateName(name) {
  try {
    if (name?.trim()?.length > 1) return true;
    return false;
  } catch (err) {
    return false;
  }
}

export function validateOAuth2Link(link = '') {
  const regExp =
    /^http(s{0,1}):\/\/.*\/oauth2\/connect\?client_id=.*(&redirect_uri=.*&response_type=.*$|&response_type=.*&redirect_uri=.*$)/;
  return regExp.test(String(link));
}

export const validateUrl = (link, optional = false) => {
  if (optional && !link) return true;
  // eslint-disable-next-line
  const re = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
  return re.test(String(link).toLowerCase());
};

export const validateMaxRange = (maxRange) => (number) => Number.parseInt(number, 10) <= maxRange;
export const validateMinRange = (minRange) => (number) => Number.parseInt(number, 10) >= minRange;
